import React, { useState, Fragment } from "react";
import axios from "axios"
import { isEmpty } from 'lodash'
import { useSelector, useDispatch } from 'react-redux';
import { Editor } from "react-draft-wysiwyg";
import {
  DatePicker,
  Modal,
  Typography,
  Space
} from "antd";
import moment from "moment";

import { setChangelogModal } from './modalsSlice'
import fire from '../App/fire';

const { Link } = Typography;

const style = {
  border: "solid",
  borderColor: "#dfe1e6",
  wordBreak: "break-word"
};

const ChangelogModal = () => {
  const dispatch = useDispatch()
  const action = useSelector(state => state.modals.changelogModal.action)
  const changelogsRedux = useSelector(state => state.changelog.data)
  const changelogDateIndex = useSelector(state => state.modals.changelogModal.date)
  const changelogContentState = useSelector(state => state.modals.changelogModal.contentState)
  const currentDate = moment().format("YYYY-MM-DD")
  let modalTitle = action === 'update' ? 'Update Changelog' : 'Add Changelog'
  let initialContentState = changelogContentState
  if (action === 'add' && changelogsRedux[currentDate] && !initialContentState) {
    modalTitle = 'Update Current Changelog'
    initialContentState = JSON.parse(changelogsRedux[currentDate])
  }
  const [contentState, setContentState] = useState(initialContentState)
  const [date, setDate] = useState(currentDate)

  const handleCloseModal = () => {
    dispatch(setChangelogModal({ open: false, action: '', date: '', contentState: { blocks: [], entityMap: {} } }))
  }

  const handleCalendarChange = value => {
    const newDate = moment(value).format("YYYY-MM-DD")
    setDate(newDate);
  };

  const handleSave = () => {
    if (action === 'add') {
      fire
        .database()
        .ref(`changelog/${date}`)
        .set(JSON.stringify(contentState));

      // Getting data from firebase
      fire
        .database()
        .ref('glipwebhooks')
        .orderByKey()
        .on('value', snapshot => {
          const glipwebhooks = snapshot.val()
          if (!isEmpty(glipwebhooks)) {
            const proxyurl = "https://cors-anywhere.herokuapp.com/";
            glipwebhooks.map(async hook => {
              if (hook.active) {
                try {
                  await axios({
                    method: 'post',
                    url: proxyurl + hook.url,
                    headers: {
                      "Content-Type": "application/json",
                    },
                    data: {
                      "activity": hook.name,
                      "title": hook.message || '',
                      "icon": hook.icon_url || 'https://yt3.ggpht.com/a/AGF-l7_s7iCi6dgwawf4rkbIMwUo6WpZLkYw0k9h4w=s100-c-k-c0xffffffff-no-rj-mo',
                      "body": `[VISP GraphQL API Changelogs - ${moment(date, 'YYYY-MM-DD').format('MMM DD, YYYY')}](http://graphql.visp.net/changelog#${date})`,
                    }
                  })
                } catch (err) {
                  console.log('Error during add Glip notification: ', err);
                  return err
                }
              }
            })
          }
        });
    } else {
      // when editing a changelog, only content should change
      // date should be the same so that the order of the actual release of schema changes are preserved
      fire
        .database()
        .ref(`changelog/${changelogDateIndex}`)
        .set(JSON.stringify(contentState));
    }

    handleCloseModal()
  };

  const handleContentStateChange = (newContent) => {
    setContentState(newContent)
  };

  return (
    <Modal
      title={modalTitle}
      visible
      okText="Save"
      onOk={handleSave}
      onCancel={handleCloseModal}
      closable={false}
      maskClosable={false}
    // width={570}
    >
      <Space direction='vertical'>
        {action === 'add' && (
          <Fragment>
            <h3>Date</h3>
            <DatePicker
              onChange={handleCalendarChange}
              defaultValue={moment()}
            />
          </Fragment>
        )}
        <Link href="https://developer.github.com/v4/changelog/" target="_blank">
          Changelog format reference.
        </Link>
        <Editor
          toolbar={{
            options: [
              "inline",
              "blockType",
              "colorPicker",
              "list",
              "link",
              "history"
            ],
            inline: {
              options: ["bold", "italic", "underline", "monospace", "strikethrough"]
            },
            list: { options: ["unordered", "ordered"] },
            link: { defaultTargetOption: "_blank", options: ["link"] },
            colorPicker: {
              colors: [
                "rgb(234,140,132)",
                "rgb(244,165,119)",
                "rgb(255,230,169)",
                "rgb(206,220,122)",
                "rgb(151,202,234)",
                "rgb(217,145,218)",
                "rgb(220,76,68)",
                "rgb(234,119,49)",
                "rgb(250,210,1)",
                "rgb(183,206,63)",
                "rgb(72,166,229)",
                "rgb(193,91,194)",
                "rgb(174,41,37)",
                "rgb(190,81,21)",
                "rgb(253,187,20)",
                "rgb(131,146,43)",
                "rgb(33,133,208)",
                "rgb(165,53,157)",
                "rgb(0,0,0)",
                "rgb(50,50,50)",
                "rgb(102,102,102)",
                "rgb(153,153,153)",
                "rgb(205,205,205)",
                "rgb(239,241,242)"
              ]
            }
          }}
          editorStyle={style}
          toolbarStyle={style}
          initialContentState={initialContentState}
          onContentStateChange={handleContentStateChange}
        />
      </Space>
    </Modal>
  )
}

export default ChangelogModal